import { createContext, useContext, useState, ReactNode } from 'react';
import { usePopoverModifier } from '@/finsight/ui/common/components/Explanations/RestrictedAccessExplanation/usePopoverModifier';

interface IDealTooltipContext {
  dealTooltipOpened: string | null,
  setDealTooltipOpened: (state: string | null) => void,
  onClick: (
    e: React.MouseEvent<HTMLTableRowElement>,
    params: { row: Record<string, any>, index: number, isExpanded: boolean },
  ) => void,
  popperModifiers: any,
}

const useDealTooltip = () => {
    const [dealTooltipOpened, setDealTooltipOpened] = useState<string | null>(null);
    const { popperModifiers, setTooltipOffset, getTooltipOffset } = usePopoverModifier();

    const onClick = (
      e: React.MouseEvent<HTMLTableRowElement>,
      params: { row: Record<string, any>, index: number, isExpanded: boolean },
    ) => {
      e.stopPropagation();
      e.preventDefault();

      const currentRowId = params.row.id;

      const newOffset = getTooltipOffset(e);
      setTooltipOffset(newOffset);
      setDealTooltipOpened(currentRowId);
    };

    return {
      dealTooltipOpened,
      setDealTooltipOpened,
      onClick,
      popperModifiers,
    };
};

const DealTooltipContext = createContext<IDealTooltipContext | undefined>(undefined);

export const DealTooltipProvider = ({ children }: { children: ReactNode }) => {
  return (
    <DealTooltipContext.Provider value={ useDealTooltip() }>
      { children }
    </DealTooltipContext.Provider>
  );
};

export const useDealTooltipContext = () => {
  const context = useContext(DealTooltipContext);
  if (!context) {
    throw new Error('useDealTooltipContext must be used within a DealTooltipProvider');
  }
  return context;
};
